// TODO: Resource Card like button will not work
// TODO: Add like button to this individual resource too.

import {
	json,
	type MetaFunction,
	type LoaderFunctionArgs,
} from '@remix-run/node'
import { useLoaderData, useSearchParams } from '@remix-run/react'
import { useState } from 'react'
import ResourceCard from '#app/components/Resource.js'
import TagsBlock, { type Tag } from '#app/components/TagsBlock.js'
import { Card } from '#app/components/ui/card.js'
import { prisma } from '#app/utils/db.server.js'

export const meta: MetaFunction = () => [
	{ title: 'Candid Garden - Discover Art' },
]

export async function loader({ params }: LoaderFunctionArgs) {
	const resourceId = params.resourceId

	const resourceData = resourceId
		? await prisma.resource.findUnique({
				where: {
					id: parseInt(resourceId),
				},
				select: {
					id: true,
					title: true,
					location: true,
					not_before: true,
					institution: true,
					path: true,
					Artist: true,
					Taggings: {
						select: {
							Tag: true,
						},
						where: {
							Tag: {
								safety: 'safe',
							},
						},
					},
					//  I think relation1 is same as relation2
					// Relation1: {
					// 	include: { Resource2: true },
					// },
					Relation2: {
						include: { Resource1: true },
					},
				},
			})
		: null

	return json({ resource: resourceData })
}

export default function Index() {
	const data = useLoaderData<typeof loader>()
	const tags = data?.resource?.Taggings.map(tagging => tagging.Tag) as Tag[]
	const relatedTo = data?.resource?.Relation2?.map(r => r.Resource1)

	const [searchParams] = useSearchParams()
	const [seletedResource, setSelectedResource] = useState<null | number>(null)
	const [,setValue] = useState(searchParams.get('search') || '')

	return (
		<main className="font-poppins flex flex-col items-center py-10">
			<section className="w-full max-w-3xl px-4">
				<h2 className="mb-4 text-center text-2xl font-semibold">
					{data.resource?.title}
				</h2>

				<div className="aspect-w-16 aspect-h-9 mb-6 overflow-hidden rounded-lg">
					<img
						src={`https://fly.storage.tigris.dev/artaigo-bucket-v1/images/${data.resource?.path}`}
						className="h-full w-full object-cover object-center"
						alt={data.resource?.title || 'resource image'}
					/>
				</div>

				<Card className="mb-6 p-4">
					{data.resource?.Artist?.name && (
						<p>
							<strong>Artist:</strong> {data.resource.Artist.name}
						</p>
					)}
					{data.resource?.not_before && (
						<p>
							<strong>Year:</strong> {data.resource.not_before}
						</p>
					)}
					{data.resource?.institution && (
						<p>
							<strong>Institution:</strong> {data.resource.institution}
						</p>
					)}
					{data.resource?.location && (
						<p>
							<strong>Location:</strong> {data.resource.location}
						</p>
					)}
				</Card>

				{!!tags && (
					<div className="w-full pb-2">
						<p className="mb-2 text-center text-lg font-medium">Tags</p>
						<TagsBlock tags={tags} />
					</div>
				)}
				{(relatedTo ?? []).length !== 0 ? (
					<>
					<h3 className="text-lg mb-2 text-center font-semibold">Related Resources</h3>
					<div className=" grid-cols-full mx-auto grid max-w-screen-lg grid-flow-dense gap-2 sm:grid-cols-2 lg:grid-cols-fluid">
						{(relatedTo ?? []).map(resource => {
							return (
								<ResourceCard
									key={resource.id}
									resource={resource}
									selectedResource={seletedResource}
									setSelectedResource={setSelectedResource}
									setValue={setValue}
									notSafe={false}
								/>
							)
						})}
					</div>
					</>
				) : null}
			</section>
		</main>
	)
}
